import React from 'react'
import BannerImageEditor from './BannerImageEditor'
import CarouselEditor from './CarouselEditor'
import EditorialEditor from './EditorialEditor'
import GoogleAdSlotEditor from './GoogleAdSlotEditor'
import HeroBannerEditor from './HeroBannerEditor'
import VideoEmbedEditor from './VideoEmbedEditor'

interface WidgetMetadataEditorProps {
  widgetType: string
  metadata: Record<string, any>
  onChange: (metadata: Record<string, any>) => void
  /** Change the widget's type. Used by the carousel editor's size/orientation selector. */
  onWidgetTypeChange?: (code: string) => void
  /** Widget id is available once the widget exists. Required for editors that upload assets. */
  widgetId?: string
}

/** Renders the appropriate metadata editor for a given widget type */
const WidgetMetadataEditor: React.FC<WidgetMetadataEditorProps> = ({ widgetType, metadata, onChange, onWidgetTypeChange, widgetId }) => {
  switch (widgetType) {
    case 'video_embed':
      return <VideoEmbedEditor metadata={metadata} onChange={onChange} />
    case 'editorial':
      return <EditorialEditor metadata={metadata} onChange={onChange} />
    case 'banner_image':
      return <BannerImageEditor metadata={metadata} onChange={onChange} widgetId={widgetId} />
    case 'google_ad_slot':
      return <GoogleAdSlotEditor metadata={metadata} onChange={onChange} />
    case 'standard_landscape_carousel':
    case 'standard_portrait_carousel':
    case 'small_landscape_carousel':
    case 'large_landscape_carousel':
      return (
        <CarouselEditor
          metadata={metadata}
          onChange={onChange}
          widgetType={widgetType}
          onWidgetTypeChange={onWidgetTypeChange}
          widgetId={widgetId}
        />
      )
    case 'hero_banner':
      return <HeroBannerEditor metadata={metadata} onChange={onChange} widgetId={widgetId} />
    default:
      return <p>No editor available for {widgetType}</p>
  }
}

export default WidgetMetadataEditor
export { BannerImageEditor, CarouselEditor, EditorialEditor, GoogleAdSlotEditor, HeroBannerEditor, VideoEmbedEditor }
